import { z } from 'zod';
import { FlowDefinitionTemplateSchema } from './flowDefinitionTemplate.js';
import { FlowDefinitionTemplateListQuerySchema, FlowDefinitionTemplateListResponseSchema, } from './list.js';
const TAGS = ['FlowDefinitionTemplate'];
export const FLOW_DEFINITION_TEMPLATES_BASE_ROUTE = '/flow-definition-templates';
export const FlowDefinitionTemplateIdParamsSchema = z.strictObject({ id: z.uuid() });
export const FlowDefinitionTemplateListRoute = {
    method: 'get',
    fullPath: FLOW_DEFINITION_TEMPLATES_BASE_ROUTE,
    summary: 'List flow templates',
    description: 'Searches the flow template library the caller can see and returns template summaries without their block graphs. Templates are the reusable starting points a flow is built from, so use this to find an existing template before proposing that a flow be built from scratch. Narrow with nameSearch, organization, visibility, or tags, and set limit rather than accepting the browse-sized default. Standard flows and skills are not returned.',
    tags: TAGS,
    query: FlowDefinitionTemplateListQuerySchema,
    response: FlowDefinitionTemplateListResponseSchema,
};
export const FlowDefinitionTemplateGetRoute = {
    method: 'get',
    fullPath: `${FLOW_DEFINITION_TEMPLATES_BASE_ROUTE}/:id`,
    summary: 'Get a flow template by id',
    description: 'Returns one flow template with its summary, markdown documentation, visibility, tags, and the complete block graph a flow created from it starts as. Keep the graph in sandbox-local code and return only the projection needed for the answer.',
    tags: TAGS,
    params: FlowDefinitionTemplateIdParamsSchema,
    response: FlowDefinitionTemplateSchema,
};
//# sourceMappingURL=routes.js.map